<template>
	<div class="login-container" >
		<div class="appheader">
			<div class="w">
				<div class="logo" @click="goHome" >
					<img :src="contact.logo" width="170" />
				</div>
			</div>
		</div>
		<div class="container">	
			<div class="content">
				<div class="lf-cover">
					<img src="../../assets/green.jpg">
				</div>
				<div class="form" >
	                 <div class="form-wrap">
	                 	<div class="form-title">
	                 	      Creat an account
	                 	</div>
	                 	 <div class="label-item">
					    	 Email
					    </div>
						<div class="form-item">
							<input type="text"  value="" placeholder="" v-model="formData.email"/>
						</div>
						<div class="label-item">
					    	 Code
					    </div>
						<div class="form-item code-item">
							<input type="text"  v-model="formData.code" placeholder="" />

							<el-button type="text" @click="getCode">
							   {{t == 61 ? 'Get code' : t + 's'}}
						    </el-button>
						</div>
						<div class="label-item">
					    	 Password
					    </div>
						<div class="form-item ">
							<input type="password"  v-model="formData.password" />
						</div>
						<div class="form-item btn-group clear-border" >
							<!-- <button type="button"  class="btn login-btn" @click="submit">Log In</button>
							 -->
							<el-button type="success" class="btn login-btn" :loading="loading" @click="submit" >Log In</el-button>

							<el-button type="text" class="btn cancel-btn" @click="$router.push('/login')">Return</el-button>

							
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>	

<script>
    import {mapState} from 'vuex'
    import { Toast } from 'vant';

	export default {
		data () {
			return {
				formData:{
                    email:"",
                    code:"",
                    password:""

				},
				loading:false,
				type:1,
				bindreg:false,
				isResetCipher: false,
				timeOut: null,
				t: 61
			}
		},
		computed: {
			 ...mapState({
                  userInfo: state => state.userInfo,
                  contact: state => state.contact,
                  bind: state => state.bind
            }),
		},
		mounted(){
            
		},
		methods: {
			goHome(){
                  this.$router.push('/')
			 },
			// submitbind(){

   //              var app= this;

   //              app.loading = true;

   //              this.$api("/login/register",this.formData ).then(function(res){

   //                  if(res.status==200){

   //                  	 app.$store.dispatch('SET_USER',res.data.user);

			// 		     app.$store.dispatch('SET_TOKEN',res.data.access_token);
                         
			// 		     setTimeout(function(){
   //                           app.$router.push("/")
			// 	         },1000)

			// 	         app.loading = false;
				       
   //                  }else{
   //                  	app.loading = false;
   //                  }

	  //           })
			// },
			submit(){
                var app= this;

                app.loading = true;

                if(this.bind){
                   this.formData.unionid  =  this.bind.unionid;
                   this.formData.openid  =  this.bind.openid;
                }

              
                this.$api("/login/register",this.formData ).then(function(res){

                    if(res.status==200){

                        app.$store.dispatch('SET_USER',res.data.user);
						app.$store.dispatch('SET_TOKEN',res.data.access_token);

						setTimeout(function(){
	                         app.$router.push("/");
					    },1000);

					    app.loading = false;
                    }else{
                    	app.loading = false;
                    }


	            })
			},
			getCode () {

				var {t} = this

				if(!this.formData.email){
					this.global_variable.showToast("please input your email")
					return
				}

				if( t <= 60) {
					return
				}
				var num = t;
				
				--num
				this.t = num;
				this.timeOut = setInterval(() => {
					--num
					if (num <= 0) {
						this.t = 61;
						clearInterval(this.timeOut);
						return
					}
					this.t = num
				}, 1000)

                if(this.bind){this.type=4}

				this.$api("/login/SendSms",{email:this.formData.email,type:this.type}).then(function(res){
                    console.log(res)

	            })


				
			}
		}
	}
</script>




// WEBPACK FOOTER //
// src/pages/login/register.vue